import "./assets/css/index.scss";
import LoadingSpinner from "./component/common/LoadingSpinnerContainer";
import LocaleProviderContainer from "./component/app/LocaleProviderContainer";
import { Provider } from "react-redux";
import React from "react";
import store from "./common/store";
import AppContent from "./component/app/AppContent";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "*",
    Component: AppContent
  }
]);

const App = () => (
  <LocaleProviderContainer store={store}>
    <Provider store={store}>
      <>
        <LoadingSpinner />
        <RouterProvider router={router} />
      </>
    </Provider>
  </LocaleProviderContainer>
);
export default App;
